/**
 * Route for `campaign-visibility-assigned-only-all-per-role`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignVisibilityAssignedOnlyAllPerRolePage } from "../features/campaign-visibility-assigned-only-all-per-role/CampaignVisibilityAssignedOnlyAllPerRolePage";

export const campaignVisibilityAssignedOnlyAllPerRoleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-visibility-assigned-only-all-per-role",
	component: CampaignVisibilityAssignedOnlyAllPerRolePage,
});

export default campaignVisibilityAssignedOnlyAllPerRoleRoute;
